import type { LicenseConfiguration } from '@/licenseManagement/licenseManagement.types';

let publishedConfiguration: LicenseConfiguration | undefined;

export function publishedLicenseValue(section: string, field: string): string {
  const value = publishedConfiguration?.[section]?.[field];
  return typeof value === 'string' && value.length > 0 ? value : '';
}

export function setPublishedLicenseConfiguration(configuration: LicenseConfiguration | undefined): void {
  publishedConfiguration = configuration;
}
